<template>
  <v-dialog :value="value" max-width="600" persistent @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="primary">
        <span class="white--text">{{ title }}</span>
      </v-card-title>
      <v-card-text class="pt-4 black--text">
        <p v-for="(line, i) in body" :key="`body-${i}`" class="mb-2">{{ line }}</p>
        <ul v-if="consequences.length" class="mb-3">
          <li v-for="(line, i) in consequences" :key="`consequence-${i}`">{{ line }}</li>
        </ul>
        <v-alert v-for="(a, i) in alerts" :key="`alert-${i}`" :type="a.type" dense outlined class="mb-3">{{ a.text }}</v-alert>
        <v-text-field
          v-if="extra"
          v-model="extraValue"
          :label="extra.label"
          :hint="extra.hint"
          :counter="extra.maxlength"
          :maxlength="extra.maxlength"
          persistent-hint
          outlined
          dense
          class="mt-2"
          autocomplete="off"
        />
        <v-checkbox
          v-if="checkbox && checkbox.shown"
          v-model="checked"
          :label="checkbox.label"
          dense
          hide-details
          class="mt-0 mb-3"
        />
        <template v-if="requireTyping">
          <p class="mt-3 mb-1">Type the CVC name to continue.</p>
          <v-text-field
            v-model="typed"
            :placeholder="cvcName"
            autocomplete="off"
            outlined
            dense
            hide-details
          />
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="cancel">Cancel</v-btn>
        <v-btn color="error" :disabled="!canProceed" @click="proceed">{{ proceedLabel }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { canProceedTyped } from "@/utils/cvcMigrationPage";

// The step dialog: the operator types the CVC name before the red button works,
// unless `requireTyping` is off (then any required tick or field still gates
// it). The caller owns `value` (open or closed) and runs the step on `proceed`.
export default {
  name: "TypeToConfirm",
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, required: true },
    body: { type: Array, default: () => [] },
    consequences: { type: Array, default: () => [] },
    cvcName: { type: String, default: "" },
    requireTyping: { type: Boolean, default: true },
    // { label, hint, maxlength, required }
    extra: { type: Object, default: null },
    // Amber or red lines under the text: [{ type: "warning" | "error", text }]
    alerts: { type: Array, default: () => [] },
    // { label, shown, required (must be ticked to proceed), checked (ticked when the dialog opens) }
    checkbox: { type: Object, default: null },
    proceedLabel: { type: String, required: true },
  },
  data: () => ({
    typed: "",
    extraValue: "",
    checked: false,
  }),
  computed: {
    canProceed () {
      return canProceedTyped({
        typed: this.typed,
        cvcName: this.cvcName,
        requireTyping: this.requireTyping,
        extra: this.extra,
        extraValue: this.extraValue,
        checkbox: this.checkbox,
        checked: this.checked,
      });
    },
  },
  watch: {
    // Every opening starts empty.
    value (open) {
      if (open) {
        this.typed = "";
        this.extraValue = "";
        this.checked = !!(this.checkbox && this.checkbox.checked);
      }
    },
  },
  methods: {
    cancel () {
      this.$emit("input", false);
      this.$emit("cancel");
    },
    proceed () {
      if (!this.canProceed) return;
      this.$emit("proceed", { extra: this.extraValue.trim(), checked: this.checked });
      this.$emit("input", false);
    },
  },
};
</script>
